import { CloseIcon, CloudDownloadIcon, DocumentIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import prettySize from 'prettysize';
import * as React from 'react';
import { DropEvent, FileRejection, useDropzone } from 'react-dropzone';

interface FileUploadProps {
  acceptTypes?: string | string[];
  onDrop?: <T extends File>(
    acceptedFiles: T[],
    fileRejections: FileRejection[],
    event: DropEvent
  ) => void;
  className?: string;
  translations: {
    attachments_label: string;
    attachments_drop_label: string;
  };
}

export const FileUpload = ({ onDrop, acceptTypes, className, translations }: FileUploadProps) => {
  const { getRootProps, getInputProps, isDragActive, isFileDialogActive } = useDropzone({
    onDrop,
    accept: acceptTypes,
  });
  const classes = classNames({
    'flex items-center p-12 border-2 border-dashed border-gray-200 bg-gray-100 rounded text-gray-500 font-medium text-xs cursor-pointer':
      true,
    'text-primary-500 border-primary-500 justify-center': isDragActive || isFileDialogActive,
    [className || '']: !!className,
  });
  return (
    <div {...(getRootProps({ className: classes }) as any)}>
      {isDragActive ? (
        <span>{translations.attachments_label}</span>
      ) : (
        <>
          <CloudDownloadIcon wrapperClass="mr-8" width="14" height="11.5" />
          <span>{translations.attachments_drop_label}</span>
        </>
      )}
      <input {...getInputProps()} />
    </div>
  );
};

export interface FileItemProps {
  className?: string;
  fileName?: string;
  fileSize?: string;
  onRemove?: () => void;
}

export const FileItem = ({ className, fileName, fileSize, onRemove }: FileItemProps) => {
  return (
    <div
      className={classNames({
        'flex items-center justify-between py-13 px-16 border border-gray-200 bg-gray-100 rounded-md':
          true,
        [className || '']: !!className,
      })}
    >
      <div className="flex items-center">
        <DocumentIcon wrapperClass="mr-15 text-lg" aria-label="document icon" />
        <div>
          <p className="font-medium text-gray-999">{fileName?.substr(0, 25)}</p>
          <p className="fon-medium text-gray-500">{prettySize(fileSize)}</p>
        </div>
      </div>
      <button className="mr-6" aria-label="close button" onClick={onRemove}>
        <CloseIcon />
      </button>
    </div>
  );
};

export const CsvFileUpload = ({
  onDrop,
  acceptTypes,
  className,
  translations,
}: FileUploadProps) => {
  const { getRootProps, getInputProps, isDragActive, isFileDialogActive } = useDropzone({
    onDrop,
    accept: acceptTypes,
  });
  const classes = classNames({
    'flex items-center p-12 border-2 border-dashed border-gray-200 bg-gray-100 rounded text-gray-500 font-medium text-xs cursor-pointer':
      true,
    'text-primary-500 border-primary-500 justify-center': isDragActive || isFileDialogActive,
    [className || '']: !!className,
  });
  return (
    <div {...(getRootProps({ className: classes }) as any)}>
      <span> Testing </span>
      {isDragActive ? (
        <span>{translations.attachments_label}</span>
      ) : (
        <>
          <CloudDownloadIcon wrapperClass="mr-8" width="14" height="11.5" />
          <span>{translations.attachments_drop_label}</span>
        </>
      )}
      <input {...getInputProps()} />
    </div>
  );
};
